import { render } from "./AllFoldersGroups.vue?vue&type=template&id=ae897940"
import script from "./AllFoldersGroups.vue?vue&type=script&lang=js"
export * from "./AllFoldersGroups.vue?vue&type=script&lang=js"

import "./AllFoldersGroups.vue?vue&type=style&index=0&id=ae897940&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__